export class ActionEntity {}
